import * as React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { compose } from 'redux';
import { withLocalization, LProps } from '../utils/wrappers';

interface Props {
  footprint: number;
  footprintPublic?: boolean;
  canManage?: boolean;
  formatNumber: (value: number, decimals?: number) => string;
  onHideFootprint?: () => void;
  onRestoreFootprint?: () => void;
}

interface FootprintProfileControlState {
  confirmHideOpen: boolean;
}

class FootprintProfileControl extends React.Component<LProps<Props>, FootprintProfileControlState> {
  public state: FootprintProfileControlState = { confirmHideOpen: false };

  private confirmHide = () => {
    const { onHideFootprint } = this.props;
    this.setState({ confirmHideOpen: false });
    if (onHideFootprint) {
      onHideFootprint();
    }
  }

  public render() {
    const { t, footprint, footprintPublic = true, canManage = false, formatNumber, onRestoreFootprint } = this.props;
    const { confirmHideOpen } = this.state;

    if (!Number.isFinite(footprint) || footprint <= 0) {
      return null;
    }

    const label = (
      <div
        className="cc__stats__label"
        dangerouslySetInnerHTML={{
          __html: t('Current Carbon Footprint')
        }}
      />
    );

    const unit = (
      <div className="cc__lighttext cc__stats__footprint_unit">{t('(mt CO2e)')}</div>
    );

    if (canManage && !footprintPublic) {
      return (
        <div className="cc__stats__item cc__stats__footprint">
          {label}
          <div className="cc__stats__footprint_body cc__lighttext cc__stats__footprint_hidden">
            <div>{t('Hidden from your profile')}</div>
            {onRestoreFootprint &&
              <button
                type="button"
                className="cc__stats__footprint_action"
                onClick={onRestoreFootprint}
              >{t('Show on profile')}</button>
            }
          </div>
        </div>
      );
    }

    if (!footprintPublic) {
      return null;
    }

    return (
      <div className="cc__stats__item cc__stats__footprint">
        {label}
        <div className="cc__stats__footprint_body">
          {canManage ? (
            <button
              type="button"
              className="cc__lighttext cc__stats__footprint_value cc__stats__footprint_value--interactive"
              onClick={() => this.setState({ confirmHideOpen: true })}
              aria-label={t('Hide carbon footprint from profile')}
              title={t('Hide from profile')}
            >
              {formatNumber(footprint)}
            </button>
          ) : (
            <div className="cc__lighttext cc__stats__footprint_value">
              {formatNumber(footprint)}
            </div>
          )}
          {unit}
        </div>
        <Modal isOpen={confirmHideOpen} backdrop="static">
          <ModalHeader>{t('Hide carbon footprint?')}</ModalHeader>
          <ModalBody>
            <p>{t('This will remove your carbon footprint from your profile page. Other users will not see it when they visit your profile.')}</p>
            <p>{t('You can restore it to your profile at any time.')}</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.confirmHide}>{t('Hide from profile')}</Button>
            <Button outline color="secondary" onClick={() => this.setState({ confirmHideOpen: false })}>{t('Cancel')}</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default compose(
  withLocalization('userStats')
)(FootprintProfileControl) as React.ComponentClass<Props>;
